import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

const StarRating = ({ rating }) => {
  const roundedRating = Math.round(rating * 2) / 2;
  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((i) => {
        if (roundedRating >= i) {
          return <FaStar key={i} className="text-yellow-400" />;
        } else if (roundedRating >= i - 0.5) {
          return <FaStarHalfAlt key={i} className="text-yellow-400" />;
        } else {
          return <FaRegStar key={i} className="text-gray-300" />;
        }
      })}
    </div>
  );
};

export default StarRating;
